import values from 'lodash/values';
import pick from 'lodash/pick';

export const getAddressTitle = (address) =>
  values(pick(address, ['address1', 'address2', 'town', 'country', 'postcode']))
    .filter(Boolean)
    .join(', ');
